// vio-table-v2's actionButtons render their own <button> elements (not ours), so they can't carry
// data-bs-toggle/data-bs-target the way our old inline table buttons did — the modal has to be
// opened/closed imperatively from the button's onClick instead.
export function openModalById(id: string) {
  const element = document.getElementById(id);
  if (element) (window as any).bootstrap.Modal.getOrCreateInstance(element).show();
}

export function closeModalById(id: string) {
  const element = document.getElementById(id);
  if (element) (window as any).bootstrap.Modal.getInstance(element)?.hide();
}
